export default {"src":"/_next/static/media/ctp-vertical-divider.c471f360.svg","height":13,"width":2,"blurWidth":0,"blurHeight":0};